import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { ASSET_URL } from '@telesoft/lib/web/constants'
import { Asset, Page } from '@telesoft/types/payload-types'
import React from 'react'
import { IoMdReturnRight } from 'react-icons/io'

export type ContactHeroMapBlockProps = Extract<Page['hero'][0], { blockType: 'contact-hero-map' }>

export default function ContactHeroMap(block: ContactHeroMapBlockProps) {
  const { title } = block
  const image = block?.image as Asset

  return (
    <div
      className="flex flex-col justify-end bg-heading min-h-[500px] relative bg-cover bg-center"
      style={{ backgroundImage: `url(${ASSET_URL}/${image?.filename})` }}
    >
      <Container className="w-full z-20 mb-8 select-none">
        <div className="col-span-full md:col-span-4 lg:col-span-6 xl:col-span-7 flex justify-start items-center">
          <IoMdReturnRight className="mr-1 text-white text-xl" />
          <Text variant="superHeading" className="text-white">
            {title || 'Contact'}
          </Text>
        </div>
      </Container>
      <div className="absolute bg-telesoft top-0 left-0 opacity-50 hover:opacity-80 transition duration-300 w-full min-h-[500px]" />
    </div>
  )
}
